// extracted by mini-css-extract-plugin
export default {"Container":"estilo_Container__DE2eS","ContainerGrid":"estilo_ContainerGrid__D7pEg"};